import { render } from "./PropertiesPage.vue?vue&type=template&id=7b31e7aa&ts=true"
import script from "./PropertiesPage.vue?vue&type=script&lang=ts"
export * from "./PropertiesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__